'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var reactIntl = require('react-intl');
var Grid = _interopDefault(require('@material-ui/core/Grid'));
var ButtonGroup = _interopDefault(require('@material-ui/core/ButtonGroup'));
var AddIcon = _interopDefault(require('@material-ui/icons/Add'));
var styledComponents = require('./styled-components.js');

var TwoToneButton = function (props) {
    var _a = props.colorLeft, colorLeft = _a === void 0 ? '#3f69e1' : _a, _b = props.colorRight, colorRight = _b === void 0 ? '#4c7cfd' : _b, _c = props.textColorLeft, textColorLeft = _c === void 0 ? 'white' : _c, _d = props.textColorRight, textColorRight = _d === void 0 ? 'white' : _d, clickHandler = props.clickHandler, text = props.text, _e = props.icon, icon = _e === void 0 ? function () { return React__default.createElement(AddIcon, { "data-testid": 'two-tone-button-default-icon' }); } : _e, hasPopUp = props.hasPopUp, ariaControls = props.ariaControls, _f = props.style, style = _f === void 0 ? {} : _f, _g = props.disabled, disabled = _g === void 0 ? false : _g, _h = props.className, className = _h === void 0 ? '' : _h;
    var intl = reactIntl.useIntl();
    var fm = intl.formatMessage;
    var disabledStyle = disabled && { opacity: '0.5' };
    return (React__default.createElement(styledComponents.IconButton, { className: className, "aria-controls": ariaControls, "aria-haspopup": hasPopUp, onClick: clickHandler, style: tslib.__assign(tslib.__assign({}, style), disabledStyle), disabled: disabled },
        React__default.createElement(Grid, { item: true },
            React__default.createElement(ButtonGroup, { variant: 'outlined', "aria-label": fm({ id: 'componentLib.twoToneButton.ariaLabel' }) },
                React__default.createElement(styledComponents.LeftButton, { colorLeft: colorLeft, textColorLeft: textColorLeft }, icon()),
                React__default.createElement(styledComponents.RightButton, { colorRight: colorRight, textColorRight: textColorRight }, text)))));
};

module.exports = TwoToneButton;
